import * as React from 'react';
import { MediaItem, TreeItem } from '../../store/types';
import { TreeArrow } from './TreeArrow';

export interface TreeNodeProps {
  item: TreeItem;
  media: MediaItem;
  isHighlighted: boolean;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

export const TreeNode: React.SFC<TreeNodeProps> = (props: TreeNodeProps) => (
  <div className="treeNode" style={{ paddingLeft: 20 * (props.item.level - 1) + (props.item.hasChildren ? 0 : 15) }}>
    <span className="treeNode arrow" onClick={props.onClick}>
      {props.item.hasChildren && <TreeArrow isExpanded={props.item.isExpanded} />}
    </span>
    {props.media.name}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/timeline/TreeNode.tsx